import React from 'react';
export function Hero() {
  return <div className="w-full mb-8 rounded-3xl overflow-hidden shadow-premium relative bg-azul-profundo" data-id="element-12">
      <div className="h-[360px] w-full relative" data-id="element-13">
        <img src="https://cdn.magicpatterns.com/uploads/wd6fyFZpobh1gnyWVxQkMc/ChatGPT_Image_4_may_2026,_07_55_56.png" alt="RenuevaTE_90 Coach" className="w-full h-full object-cover object-center" data-id="element-14" />
        {/* Gradient overlay for text legibility */}
        <div className="absolute inset-0 bg-gradient-to-t from-azul-profundo via-azul-profundo/40 to-transparent" data-id="element-15"></div>
      </div>

      <div className="absolute bottom-0 left-0 w-full p-8 text-center" data-id="element-16">
        <h1 className="font-serif text-4xl md:text-5xl text-blanco-perla mb-3 drop-shadow-md" data-id="element-17">
          Diagnóstico RenuevaTE_90
        </h1>
        <p className="text-plateado text-sm md:text-base tracking-wide uppercase font-medium" data-id="element-18">
          Despertar del cuerpo · nutrición · bienestar · mente · espíritu
        </p>
      </div>
    </div>;
}